import { render, staticRenderFns } from "./userRetention.vue?vue&type=template&id=3c44e682&"
import script from "./userRetention.vue?vue&type=script&lang=js&"
export * from "./userRetention.vue?vue&type=script&lang=js&"
import style0 from "./userRetention.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports